module.exports = __webpack_public_path__ + "img/edits-move.a4d72374.svg";